/* unplugin-vue-components disabled */import script from "./course-seaction-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./course-seaction-header.vue?vue&type=script&setup=true&lang=ts"

import "./course-seaction-header.vue?vue&type=style&index=0&id=0fdc8fde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fdc8fde"]])

export default __exports__